const STRUCT = {
  CATEGORY_ID: 'categoryId',
  ID: 'id',
  TITLE: 'title',
};

export default STRUCT;
